import { render, staticRenderFns } from "./InfoPribadi.vue?vue&type=template&id=21e6cb55&"
import script from "./InfoPribadi.vue?vue&type=script&lang=js&"
export * from "./InfoPribadi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports